import adminMenu from './adminMenu';
import adminOther from './adminOther';
import { settings, vendorSettings } from './settings';
import vendorMenu from './vendorMenu';

// ==============================|| MENU ITEMS ||============================== //
const menuItems = {
    items: [],
    vendor: [...vendorMenu, vendorSettings],
    staff: [...vendorMenu, vendorSettings],
    admin: [...adminMenu, settings],
    manager: [...adminMenu, settings],
    finance: [...adminMenu, settings],
    support: [...adminMenu, settings],
    customer_care: [...adminMenu, settings],
    agent: [...adminMenu, settings]
};

export default menuItems;
